export enum UserRole {
  CompanyUser = 'COMPANY_USER',
  CompanyAdmin = 'COMPANY_ADMIN',
  AuthorizedUser = 'AUTHORIZED_USER',
  /** Administrator of one tenant (renamed from ADMIN in WB-218). */
  Admin = 'TENANT_ADMIN',
  /** Platform administrator: every tenant (WB-218). */
  SuperAdmin = 'SUPER_ADMIN',
}

export const CompanyAdminListableRoles = [UserRole.CompanyAdmin, UserRole.CompanyUser];
